/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsResetPassword
 */
export interface MelcoModelsResetPassword {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsResetPassword
     */
    user_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsResetPassword
     */
    code?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsResetPassword
     */
    new_password?: string | null;
}

export function MelcoModelsResetPasswordFromJSON(json: any): MelcoModelsResetPassword {
    return MelcoModelsResetPasswordFromJSONTyped(json, false);
}

export function MelcoModelsResetPasswordFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsResetPassword {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user_name': !exists(json, 'user_name') ? undefined : json['user_name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'new_password': !exists(json, 'new_password') ? undefined : json['new_password'],
    };
}

export function MelcoModelsResetPasswordToJSON(value?: MelcoModelsResetPassword | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user_name': value.user_name,
        'code': value.code,
        'new_password': value.new_password,
    };
}


